import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { handleApiError } from "@/utils/errors";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,
      refetchOnWindowFocus: "always",
      retry: 1,
    },
  },
  mutationCache: new MutationCache({
    onError: (error) => {
      const { message } = handleApiError(error);
      toast.error(message);
    },
  }),
  queryCache: new QueryCache({
    onError: (error) => {
      const { message } = handleApiError(error);
      toast.error(message);
    },
  }),
});
